// extracted by mini-css-extract-plugin
export default {"textArea":"TextAreaCore_textArea__frSGM"};